import BigNumber from '@/utils/number';

// 两个数值是否相等
export const isEqualVal = (leftVal, rightVal) => new BigNumber(leftVal).isEqualTo(rightVal);

// 左边数值 是否 大于右边数值
export const isGreaterVal = (leftVal, rightVal) => new BigNumber(leftVal).isGreaterThan(rightVal);
